import React from 'react';
import './YouthPrograms.css';

const YouthPrograms = () => {
  return (
    <section className="youth-programs">
      <div className="youth-programs-wrapper">
        <h2 className="youth-programs-section-title">Our Youth Programs</h2>
        <div className="youth-programs-grid">
          <div className="youth-programs-card">
            <h3>Mentorship</h3>
            <p>Connecting young people with experienced mentors in various fields.</p>
          </div>
          <div className="youth-programs-card">
            <h3>Leadership Training</h3>
            <p>Empowering youth with leadership skills for the future.</p>
          </div>
          <div className="youth-programs-card">
            <h3>Entrepreneurship</h3>
            <p>Supporting youth in starting and growing their own businesses.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YouthPrograms;